export default {
  getterMyCategories       : state => state.myCategories,
  getterMyCategoriesCount  : state => state.myCategoriesCount,
  getterMyDisciplinesCount : state => state.myDisciplinesCount
};
